// Web counterparts to the mobile app's utils/messagingUtils.js. Phones are
// stored in E.164 ("+234...").

// wa.me works everywhere: it opens the WhatsApp app on phones and WhatsApp
// Web / the desktop app on computers. It wants digits only, no "+".
export const buildWhatsAppUrl = (phone, message) => {
  const digits = String(phone).replace(/\D/g, "");
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${digits}${text}`;
};

export const buildSmsUrl = (phone, message) =>
  message ? `sms:${phone}?body=${encodeURIComponent(message)}` : `sms:${phone}`;

// sms: links only do something useful on phones/tablets, so SMS-only shops
// get no Message button on desktop. iPadOS reports itself as a Mac, hence the
// touch check.
export const canSendSms = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return (
    /Android|iPhone|iPad|iPod/i.test(ua) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
  );
};
